import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

@Component({
  selector: 'eventq-panel-tab',
  templateUrl: './panel-tab.html',
  styleUrl: './panel-tab.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EventqPanelTab {
  readonly label = input.required<string>();
  readonly active = input(false);

  readonly selected = output<void>();
}
